import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../auth';

/** Ends the PIN session and returns the iPad to the name grid. Only rendered on a kiosk session. */
function KioskSwitchButton({ className, role }) {
    const { switchKioskTrainer } = useAuth();
    return (
        <button type="button" role={role} className={className} onClick={() => switchKioskTrainer()}>
            Switch trainer
        </button>
    );
}

KioskSwitchButton.propTypes = {
    className: PropTypes.string,
    role: PropTypes.string,
};

export default KioskSwitchButton;
